import { createFileRoute, Link } from "@tanstack/react-router";
import { AppLegalLayout } from "@/components/AppLegalLayout";

const TITLE = "Exclusão de conta | Nook Gym";
const DESC = "Como excluir sua conta do app Nookers, o que é apagado e o que é mantido.";

export const Route = createFileRoute("/excluir-conta")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://nookgym.com.br/excluir-conta" }],
  }),
  component: Page,
});

function Page() {
  return (
    <AppLegalLayout title="Exclusão de conta">
      <p>
        Você pode excluir sua conta do <strong>Nookers</strong> a qualquer momento, sozinho, sem falar com ninguém.
      </p>

      <h2>Pelo aplicativo</h2>
      <ol>
        <li>Abra o app e entre na sua conta.</li>
        <li>Vá em <strong>Perfil</strong> → aba <strong>Configurações</strong>.</li>
        <li>Toque em <strong>Excluir minha conta</strong>.</li>
        <li>Confirme digitando <strong>EXCLUIR</strong>. A exclusão acontece na hora e não tem como desfazer.</li>
      </ol>

      <h2>Sem o aplicativo</h2>
      <p>
        Se você já desinstalou o app ou perdeu o acesso, escreva para{" "}
        <a href="mailto:privacidade@nookgym.com.br">privacidade@nookgym.com.br</a> a partir do e-mail cadastrado. A exclusão é feita em até 7 dias corridos.
      </p>

      <h2>O que é apagado</h2>
      <ul>
        <li>Seu acesso ao aplicativo: login, senha e sessões abertas.</li>
        <li>Seu perfil no app e as fotos que você enviou.</li>
        <li>Pesagens, bioimpedância, medidas corporais e avaliações físicas.</li>
        <li>Respostas do PAR-Q, anamnese e restrições médicas.</li>
        <li>Histórico de treinos, cargas, desempenho e prescrições.</li>
        <li>Plano alimentar e fotos de refeições.</li>
        <li>Dados importados do Apple Saúde ou do Health Connect.</li>
        <li>A conexão com o Strava e as atividades importadas de lá.</li>
        <li>Agendamentos, check-ins, publicações e conexões com outros alunos.</li>
        <li>Notificações e o registro do seu aparelho.</li>
      </ul>

      <h2>O que é mantido, e por quê</h2>
      <p>
        Enquanto você tiver contrato com a academia — ou enquanto durar o prazo legal de guarda depois dele —, seu cadastro de aluno (nome e contato) e os registros de contrato, mensalidades e pagamentos continuam existindo no sistema da Nook Gym. Não é escolha nossa: nota fiscal e cobrança não existem sem identificação do contratante, e a LGPD prevê essa retenção no art. 16, I, para cumprimento de obrigação legal.
      </p>
      <p>
        O que acaba é o vínculo entre esse cadastro e tudo que é dado de saúde: após a exclusão, não resta no sistema nenhuma pesagem, avaliação, PAR-Q ou histórico de treino seu.
      </p>
      <p>Encerrado o contrato e vencidos os prazos legais, você pode pedir a eliminação também desse cadastro por e-mail.</p>

      <h2>Excluir a conta encerra minha matrícula?</h2>
      <p>
        Não. Excluir a conta apaga seu acesso ao aplicativo e seus dados de treino. O cancelamento do contrato com a academia é um pedido separado, feito na recepção.
      </p>

      <p>
        Mais detalhes sobre o tratamento dos seus dados na{" "}
        <Link to="/politica-de-privacidade">Política de Privacidade</Link>.
      </p>
    </AppLegalLayout>
  );
}
